// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, SchemaForm } from "@components";
import uiSchema from "./ui-schema";
import "./styles.scss";
import { parseSchema } from "@utils/schema";

type Props = $Exact<{
  onDismissHandler: () => void,
  onSubmit: (form: Object) => void,
  clientId: ?number,
  absenceId: number,
  ...PropsFromLocalize,
}>;

type State = $Exact<{
  schema: Object,
}>;

export class AddAbsenceDocumentModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    // Class components needs constructor for accessing the SchemaForm's ref
    this.formRef = React.createRef();
    this.state = {
      schema: {},
    };
  }

  componentDidMount() {
    if (!this.props.clientId || !this.props.absenceId) {
      return;
    }

    parseSchema("AbsenceDocumentDTO", {
      clientId: this.props.clientId,
      absenceId: this.props.absenceId,
    }).then(schema => {
      this.setState({ schema });
    });
  }

  submitForm = () => {
    if (this.formRef.current) {
      this.formRef.current.submit();
    }
  };

  handleSubmit = (form: Object) => {
    this.props.onSubmit(form);
  };

  get uiSchema() {
    return uiSchema(this.props.t);
  }

  render() {
    return (
      <Modal className="modal-normal">
        <ModalHeader toggle={this.props.onDismissHandler}>
          {this.props.t("ADD_DOCUMENT")}
        </ModalHeader>
        <ModalBody>
          <SchemaForm
            ref={this.formRef}
            schema={this.state.schema}
            onSubmit={this.handleSubmit}
            uiSchema={this.uiSchema}
            formData={null}
            externalSubmit
          />
        </ModalBody>
        <ModalFooter className="d-flex justify-content-end">
          <Button color="secondary" onClick={this.props.onDismissHandler}>
            {this.props.t("CANCEL")}
          </Button>
          <Button materialIcon="upload_file" onClick={this.submitForm}>
            {this.props.t("UPLOAD")}
          </Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default localize()(AddAbsenceDocumentModal);
